var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ProductionReturn',{attrs:{"return-type":"BC"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }